import axios from 'axios';
import { translate } from 'react-jhipster';

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

export const ACTION_TYPES = {
  CREATE_ACCOUNT: 'register/CREATE_ACCOUNT',
  CREATE_ACCOUNT_TOKEN: 'register/CREATE_ACCOUNT_TOKEN',
  CREATE_ACCOUNT_SIM: 'register/CREATE_ACCOUNT_SIM',
  ADD_AUTH_TOKEN: 'register/ADD_AUTH_TOKEN',
  ADD_AUTH_SIM: 'register/ADD_AUTH_SIM',
  GET_TOTP: 'register/GET_TOTP',
  GET_INFO: 'register/GET_INFO',
  RESET: 'register/RESET',
  GET_IDP: 'register/GET_IDP',
  SIGN_SMART_ID: 'register/SIGN_SMART_ID',
  RESULT_REGISTER_SMART_ID: 'register/RESULT_REGISTER_SMART_ID',
  REGISTER_SMART_ID: 'register/REGISTER_SMART_ID',
  REGISTER_SMART_CA: 'register/REGISTER_SMART_CA',
  SIGN_HASH_SMART_CA: 'register/SIGN_HASH_SMART_CA',
  ADD_SMART_CA: 'register/ADD_SMART_CA',
  CREATE_ACCOUNT_ORG: 'register/CREATE_ACCOUNT_ORG',
  CREATE_ACCOUNT_ORG_INFO: 'register/CREATE_ACCOUNT_ORG_INFO',
  CREATE_ACCOUNT_CCVC: 'register/CREATE_ACCOUNT_CCVC',
  UPLOAD_FILE: 'register/UPLOAD_FILE'
};

const initialState = {
  loading: false,
  registrationSuccess: false,
  registrationFailure: false,
  regTokenFailure: false,
  getInfoFailure: false,
  errorMessage: null,
  resultReg: {} as any,
  totp: {} as any,
  resultRegSim: {} as any,
  resultRegToken: {} as any,
  infoCert: {} as any,
  resultAdd: {} as any,
  idp: {
    data: [] as any
  } as any,
  responseSignSmartID: {} as any,
  responseResultSignSmartID: {} as any,
  responseRegSmartID: {} as any,
  responseSignHashSmartCA: {} as any,
  responseRegSmartCA: {} as any,
  signHashSmartCAFails: false,
  resultRegOrg: {} as any,
  resultRegOrgInfo: {} as any,
  resultRegCCVC: {} as any,
  responseUpload: '' as any
};

export type RegisterState = Readonly<typeof initialState>;

// Reducer
export default (state: RegisterState = initialState, action): RegisterState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.CREATE_ACCOUNT):
    case REQUEST(ACTION_TYPES.CREATE_ACCOUNT_TOKEN):
    case REQUEST(ACTION_TYPES.GET_TOTP):
    case REQUEST(ACTION_TYPES.CREATE_ACCOUNT_SIM):
    case REQUEST(ACTION_TYPES.GET_INFO):
    case REQUEST(ACTION_TYPES.ADD_AUTH_TOKEN):
    case REQUEST(ACTION_TYPES.ADD_AUTH_SIM):
    case REQUEST(ACTION_TYPES.GET_IDP):
    case REQUEST(ACTION_TYPES.SIGN_SMART_ID):
    case REQUEST(ACTION_TYPES.RESULT_REGISTER_SMART_ID):
    case REQUEST(ACTION_TYPES.REGISTER_SMART_ID):
    case REQUEST(ACTION_TYPES.SIGN_HASH_SMART_CA):
    case REQUEST(ACTION_TYPES.REGISTER_SMART_CA):
    case REQUEST(ACTION_TYPES.ADD_SMART_CA):
    case REQUEST(ACTION_TYPES.CREATE_ACCOUNT_ORG):
    case REQUEST(ACTION_TYPES.CREATE_ACCOUNT_ORG_INFO):
    case REQUEST(ACTION_TYPES.CREATE_ACCOUNT_CCVC):
    case REQUEST(ACTION_TYPES.UPLOAD_FILE):
      return {
        ...state,
        loading: true
      };
    case FAILURE(ACTION_TYPES.CREATE_ACCOUNT):
    case FAILURE(ACTION_TYPES.CREATE_ACCOUNT_ORG):
    case FAILURE(ACTION_TYPES.CREATE_ACCOUNT_ORG_INFO):
      return {
        ...initialState,
        registrationFailure: true,
        registrationSuccess: false,
        errorMessage: action.payload.response.data.errorKey
      };
    case FAILURE(ACTION_TYPES.CREATE_ACCOUNT_TOKEN):
    case FAILURE(ACTION_TYPES.ADD_AUTH_TOKEN):
      return {
        ...initialState,
        regTokenFailure: true
      };
    case SUCCESS(ACTION_TYPES.CREATE_ACCOUNT):
      // case SUCCESS(ACTION_TYPES.CREATE_ACCOUNT_ORG):
      // case SUCCESS(ACTION_TYPES.CREATE_ACCOUNT_ORG_INFO):
      return {
        ...initialState,
        registrationSuccess: true,
        registrationFailure: false,
        resultReg: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_ACCOUNT_ORG):
      return {
        ...state,
        registrationSuccess: true,
        registrationFailure: false,
        resultRegOrg: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_ACCOUNT_ORG_INFO):
      return {
        ...initialState,
        registrationSuccess: true,
        registrationFailure: false,
        resultRegOrgInfo: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_ACCOUNT_CCVC):
      return {
        ...initialState,
        registrationSuccess: true,
        registrationFailure: false,
        resultRegCCVC: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.GET_TOTP):
      return {
        ...initialState,
        totp: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_ACCOUNT_TOKEN):
    case SUCCESS(ACTION_TYPES.CREATE_ACCOUNT_SIM):
    case SUCCESS(ACTION_TYPES.ADD_AUTH_TOKEN):
    case SUCCESS(ACTION_TYPES.ADD_AUTH_SIM):
      return {
        ...initialState,
        regTokenFailure: false,
        resultRegSim: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.GET_INFO):
      return {
        ...initialState,
        infoCert: action.payload.data,
        getInfoFailure: false
      };
    case SUCCESS(ACTION_TYPES.SIGN_HASH_SMART_CA):
      return {
        ...initialState,
        responseSignHashSmartCA: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.REGISTER_SMART_CA):
    case SUCCESS(ACTION_TYPES.ADD_SMART_CA):
      return {
        ...initialState,
        responseRegSmartCA: action.payload.data,
        signHashSmartCAFails: false
      };
    case SUCCESS(ACTION_TYPES.SIGN_SMART_ID):
      return {
        ...initialState,
        responseSignSmartID: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.RESULT_REGISTER_SMART_ID):
      return {
        ...initialState,
        responseResultSignSmartID: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.REGISTER_SMART_ID):
      return {
        ...initialState,
        responseRegSmartID: action.payload.data
      };
    case FAILURE(ACTION_TYPES.SIGN_HASH_SMART_CA):
      return {
        ...initialState,
        signHashSmartCAFails: true
      };
    case FAILURE(ACTION_TYPES.GET_INFO):
      return {
        ...initialState,
        getInfoFailure: true
      };
    case SUCCESS(ACTION_TYPES.GET_IDP):
      return {
        ...state,
        idp: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.UPLOAD_FILE):
      return {
        ...initialState,
        responseUpload: action.payload.data
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

// Actions
export const handleRegister = user => ({
  type: ACTION_TYPES.CREATE_ACCOUNT,
  payload: axios.post('api/register', user)
});

// export const handleRegister = (user, type) => ({
//   type: ACTION_TYPES.CREATE_ACCOUNT,
//   payload: axios.post('api/register', { ...user, type }),
// });

export const handleRegisterToken = (signed, cert, otp, userType, email, captcha, unitname, identity, unitCode) => ({
  type: ACTION_TYPES.CREATE_ACCOUNT_TOKEN,
  payload: axios.post('api/register/usbtoken', { signed, cert, otp, userType, email, captcha, unitname, identity, unitCode })
});

// Actions
export const handleRegisterSIM = (cert, userType, email, phone, captcha, provider) => ({
  type: ACTION_TYPES.CREATE_ACCOUNT_SIM,
  payload: axios.post('api/register/pki', { cert, userType, email, phone, captcha, provider })
});

export const handleAddToken = (signed, cert, otp, userType, email, id) => ({
  type: ACTION_TYPES.ADD_AUTH_TOKEN,
  payload: axios.post('api/register/add/pki', { signed, cert, otp, userType, email, id })
});

export const handleAddSIM = (cert, userType, email, phone, id, provider) => ({
  type: ACTION_TYPES.ADD_AUTH_SIM,
  payload: axios.post('api/register/add/pki', { cert, userType, email, phone, id, provider })
});

export const handleGetTotp = () => ({
  type: ACTION_TYPES.GET_TOTP,
  payload: axios.get('api/register/totp')
});

export const handleGetInfo = (phone, homeNetwork, userType?) => ({
  type: ACTION_TYPES.GET_INFO,
  payload: axios.post('api/register/pki/info', null, {
    params: {
      phone: phone,
      msspProvider: homeNetwork,
      userType: userType
    }
  })
});

export const reset = () => ({
  type: ACTION_TYPES.RESET
});

export const handleGetIDP = () => ({
  type: ACTION_TYPES.GET_IDP,
  payload: axios.get('/api/register/listIdp')
});

// register smart ca
const httpClient = axios.create();
httpClient.defaults.timeout = 7 * 60 * 1000;
export const signHashSmartCA = (code, redirectUri) => ({
  type: ACTION_TYPES.SIGN_HASH_SMART_CA,
  payload: httpClient.post('api/register/sign/smartCA', { code, redirectUri }, null)
});

export const handleRegisterSmartCA = dict => ({
  type: ACTION_TYPES.REGISTER_SMART_CA,
  payload: axios.post('api/register/smartCA', dict, null)
});

export const handleAddSmartCA = dict => ({
  type: ACTION_TYPES.ADD_SMART_CA,
  payload: axios.post('api/register/add/smartCA', dict, null)
});

// register smart id
export const signSmartID = userIdentity => ({
  type: ACTION_TYPES.SIGN_SMART_ID,
  payload: axios.post('api/register/sign/smartID', userIdentity, null)
});

// register smart id
// const httpClient = axios.create();
// httpClient.defaults.timeout = 150000;
// export const getResultSignSmartID = dict => ({
//   type: ACTION_TYPES.RESULT_REGISTER_SMART_ID,
//   payload: httpClient.post('api/register/result/sign/smartID', dict, null)
// });

// register smart id
export const registerSmartID = dict => ({
  type: ACTION_TYPES.REGISTER_SMART_ID,
  payload: axios.post('api/register/smartID', dict, null)
});

export const handleRegisterOrg = user => ({
  type: ACTION_TYPES.CREATE_ACCOUNT_ORG,
  payload: axios.post('api/register/org', user)
});

export const handleRegisterOrgINFO = email => ({
  type: ACTION_TYPES.CREATE_ACCOUNT_ORG_INFO,
  payload: axios.get('api/register/info/by-email?email=' + email)
});

export const handleRegisterCCVC = (email, type) => ({
  type: ACTION_TYPES.CREATE_ACCOUNT_CCVC,
  payload: axios.get('api/register/ccvc/otp/' + email + '?type=' + type)
});

export const handleRegisterUpload = formData => ({
  type: ACTION_TYPES.UPLOAD_FILE,
  payload: axios.post('api/register/upload', formData)
});
